import { FunctionComponent, useCallback } from 'react'
import { Card, CardContent, Grid } from '@mui/material'
import { Login as LoginModule, LoginFormInputOptions } from '@dxp-module/login'
import clsx from 'clsx'
import {
  useDxpPreviewParam,
  useNavigateWithPreview,
  usePlatformConfig,
} from '@dxp-module/common'
import { labels, errors } from '../../../common/constants/LoginTranslations'
import ROUTES from '../../../common/enum/Routes'
import SignInUpLink from '../../../common/components/signupLink/SignInUpLink'
import loginContainerStyles from './loginContainer.styles'

type LoginContainerProps = {
  formOptions?: LoginFormInputOptions
  className?: string
  hideSignup?: boolean
}

const LoginContainer: FunctionComponent<LoginContainerProps> = ({
  formOptions,
  className,
  hideSignup,
}) => {
  const styles = loginContainerStyles()
  const {
    platformConfig: {
      myAccount: { isSeparateSignupLogin },
    },
  } = usePlatformConfig()
  const previewSearchParam = useDxpPreviewParam()
  const navigateWithPreview = useNavigateWithPreview()

  const handleLoginSuccess = useCallback(() => {
    navigateWithPreview(ROUTES.MYACCOUNT_BASE)
  }, [navigateWithPreview])

  const handleForgotPassword = useCallback(
    () => navigateWithPreview(ROUTES.MYACCOUNT_FORGOT_PASSWORD),
    [navigateWithPreview]
  )

  return (
    <Grid
      item
      xs={12}
      md={6}
      data-test="my-account:login"
      className={clsx([styles.root, className])}
    >
      <Card className={styles.card}>
        <CardContent className={styles.cardContent}>
          <Grid container>
            <Grid item xs={12}>
              <LoginModule
                labels={labels}
                errors={errors}
                formInputOptions={formOptions}
                onLoginSuccess={handleLoginSuccess}
                onForgotPassword={handleForgotPassword}
                classes={{
                  title: styles.title,
                  subTitleContainer: styles.subTitleContainer,
                  subTitle: styles.subTitle,
                  subTitleSecondary: styles.subTitleSecondary,
                }}
              />
            </Grid>
          </Grid>
          {isSeparateSignupLogin && !hideSignup && (
            <SignInUpLink
              textId="trans__myaccount__login__sign_up_description"
              linkId="trans__myaccount__login__sign_up_cta"
              path={`${ROUTES.MYACCOUNT_SIGNUP}${
                previewSearchParam && `?${previewSearchParam}`
              }`}
              testId="my-account:signupLink"
              classes={{
                text: styles.text,
                link: styles.link,
              }}
            />
          )}
        </CardContent>
      </Card>
    </Grid>
  )
}

export default LoginContainer
